import { css } from '@/styled-system/css';
import { shimmerStyles } from '@zg-rentals/loading-components';

export const propertyPhotoContainerStyles = css.raw({
  display: { base: 'none', mobile390: 'inherit' },
  width: { mobile390: '76px' },
  height: { mobile390: '76px', lg: '87px' },
  borderRadius: { mobile390: 'obj.default' },
  marginBottom: { mobile390: '400', lg: '0px' },
  marginRight: { mobile390: '200', lg: '400' },
  minWidth: { lg: '87px', xl: '122px' },
  maxWidth: { lg: '87px', xl: '122px' },
  ...shimmerStyles,
});

export const backLinkStyles = css.raw({
  marginRight: '400',
  alignSelf: 'center',
  lg: {
    marginRight: '600',
  },
});
